/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RunClubEventDistanceDto
 */
export interface RunClubEventDistanceDto {
    /**
     * Distance value
     * @type {number}
     * @memberof RunClubEventDistanceDto
     */
    'distanceValue': number;
    /**
     * Distance unit
     * @type {string}
     * @memberof RunClubEventDistanceDto
     */
    'distanceUnit': RunClubEventDistanceDtoDistanceUnitEnum;
    /**
     * Label
     * @type {object}
     * @memberof RunClubEventDistanceDto
     */
    'label'?: object;
}

export const RunClubEventDistanceDtoDistanceUnitEnum = {
    Km: 'km',
    Mi: 'mi'
} as const;

export type RunClubEventDistanceDtoDistanceUnitEnum = typeof RunClubEventDistanceDtoDistanceUnitEnum[keyof typeof RunClubEventDistanceDtoDistanceUnitEnum];


